export default "__VITE_ASSET__a42fd09b__"